import React, {Component} from 'react'
import styles from './SliderNavigation.css'
import Svg from "../Svg/Svg"
import {Icon, LIB} from '../../constants/consts-types'
import PropTypes from "prop-types"

class SliderNavigation extends Component {
  static propTypes = {
    onSliderNavClick: PropTypes.func.isRequired,
    numItems: PropTypes.number.isRequired,
    currentIndex: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      inView: false
    }

    this.onKeyUp = this.onKeyUp.bind(this)
    this.createObserver = this.createObserver.bind(this)
  }

  componentDidMount() {
    window.addEventListener('keyup', this.onKeyUp)
    this.createObserver()
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.onKeyUp)
    if(this.observer) this.observer.disconnect()
  }

  createObserver() {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        this.setState({
          inView: Boolean(entry.intersectionRatio > 0)
        })
      })
    })

    this.observer.observe(this.sliderNavigation)
  }

  onKeyUp(event) {
    if(!this.state.inView) return

    switch(event.key) {
      case 'ArrowLeft':
        this.props.onSliderNavClick(-1)
        break
      case 'ArrowRight':
        this.props.onSliderNavClick(1)
        break
      default:
        break
    }
  }

  render() {
    const {
      onSliderNavClick,
      numItems,
      currentIndex
    } = this.props

    return (
      <div
        ref={node => this.sliderNavigation = node}
        className={styles.SliderNavigation}
      >
        <div className={styles.navButtons}>
          <div className={styles.buttonWrapper}>
            <button
              aria-label={LIB.previous}
              className={styles.buttonNav}
              onClick={() => onSliderNavClick(-1)}
              disabled={currentIndex === 0}
            >
              <Svg id={Icon.ARROW_LEFT}/>
            </button>
            <button
              aria-label={LIB.next}
              className={styles.buttonNav}
              onClick={() => onSliderNavClick(1)}
              disabled={currentIndex === numItems - 1}
            >
              <Svg id={Icon.ARROW_RIGHT}/>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default SliderNavigation;



// WEBPACK FOOTER //
// ./src/components/SliderNavigation/SliderNavigation.js